export default __webpack_public_path__ + "img/work.a011c9ff.png";